/* eslint-disable no-unused-vars */
import React from "react";
import { useState } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";

import './Works.css';

// Import ../../assets/recentprojects/
import Portfolio from '../../assets/recentprojects/react-portfolio.png';
import Veritru from '../../assets/recentprojects/veritru.png';
import URL_Aggregator from '../../assets/recentprojects/url_aggre.png';
import Mafia from '../../assets/recentprojects/mafia.png';
import Lofo from '../../assets/recentprojects/lofo.png';
import Startup from '../../assets/recentprojects/startup.png';
import Lacalle from '../../assets/recentprojects/lacalle.png';

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();
  const [projects, setProjects] = useState([
    { 
      id: 1,
      title: 'URL Aggregator', 
      description: `URL Aggregator is a platform where a user can add various links and create a public URL that they can then share with anyone. Connect audiences to all of your content with just one link.`,
      alter: 'URL Aggregator', 
      image: `${URL_Aggregator}`,
    },
    { 
      id: 2,
      title: 'Mafia', 
      description: `Mafia is a command Line based Game build with OOPs concept wtih JAVA. It is a popular party game that requires one to think, manipulate, and deceive others in order to win`,
      alter: 'Mafia',
      image: `${Mafia}`,
    }
  ]);

  return (
    <section id="works">
      <Container component="main" className={classes.main} maxWidth="md">
        {projects.map((project) => (
          <div className="project" key={ project.id }>
            <div className="__img_wrapper">
              <img src={ project.image } alt={ project.alter }/>
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={ project.id + '. ' + project.title } />
              </h3>
              <p className="description">
                { project.description }
              </p>
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
};
